import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

// Non-intrusive banner that lets users install the PWA to their home screen.
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("mbv_install_dismissed") === "1") return;
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", () => setVisible(false));
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem("mbv_install_dismissed", "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="install-prompt" className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[130] w-[min(94vw,420px)]">
      <div className="flex items-center gap-3 bg-espresso text-cream rounded-2xl px-4 py-3 shadow-xl">
        <img src="/icon-192.png" alt="MO by Vir" className="w-10 h-10 rounded-lg" />
        <div className="flex-1 leading-tight">
          <div className="text-sm font-medium">Instala MO by Vir</div>
          <div className="text-[11px] text-cream/70">Ábrela como una app desde tu pantalla de inicio.</div>
        </div>
        <button data-testid="install-accept" onClick={install} className="inline-flex items-center gap-1.5 bg-rose text-white rounded-full px-3.5 py-2 text-xs font-medium hover:opacity-90 transition">
          <Download size={14} /> Instalar
        </button>
        <button data-testid="install-dismiss" onClick={dismiss} className="text-cream/60 hover:text-cream"><X size={18} /></button>
      </div>
    </div>
  );
}
